import { render, staticRenderFns } from "./listwarning.vue?vue&type=template&id=015d3dcf&scoped=true&"
import script from "./listwarning.vue?vue&type=script&lang=js&"
export * from "./listwarning.vue?vue&type=script&lang=js&"
import style0 from "./listwarning.vue?vue&type=style&index=0&id=015d3dcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d3dcf",
  null
  
)

export default component.exports